<template>
  <div id="app">
    <my-header v-if="$route.name != 'Login'"></my-header>
    <router-view></router-view>
    <my-footer v-if="$route.name != 'Login'"></my-footer>
  </div>
</template>

<script>
import MyHeader from './components/MyHeader'
import MyFooter from './components/MyFooter'

export default {
  name: 'app',
  components: {
    MyHeader,
    MyFooter
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="less">
@import '~normalize.css/normalize.css';
@import '~nprogress/nprogress.css';

* {
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  height: 100%;
  min-width: 1100px;
  color: #000000;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  font-size: 16px;
  color: #333;
  padding-top: 60px;
}

.page {
  min-height: 100%;
  position: relative;
}

.container {
  width: 1470px;
  position: relative;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 15px;
  height: 100%;
}

.clearfix:before,.clearfix:after {
  display: table;
  content: " "
}

.clearfix:after {
  clear: both
}

a {
  text-decoration: none;
  color: black;
}

.loading {
  text-align: center;
  font-size: 32px;
  margin-top: 60px;
}

.films-title {
  font-size: 28px;
  margin-top: 50px;
}

.films-subtitle {
  font-size: 14px;
  margin-top: 8px;
  font-weight: 500;
}

.films-list {
  margin-left: -80px;
  margin-top: -40px;

  .film-item {
    width: 300px;
    height: 478px;
    border-radius: 30px;
    margin-top: 90px;
    margin-left: 80px;
    float: left;
    overflow: hidden;
    background-color: white;
    box-shadow: 0 3px 18px 0 #bbb;
    display: block;
    transition: box-shadow 250ms;
    animation: film 420ms linear forwards;
    transform: translateY(-40%);
    opacity: 0;

    &:hover {
      box-shadow: 0 3px 18px 0 #a5a5a5;
    }

    .film-header {
      height: 300px;
      background: #f8f8f8 no-repeat center center/ cover;
      border-radius: 30px 30px 0 0;
    }

    .film-content {
      padding: 28px 30px;
    }

    .en-ttile {
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .cn-title {
      font-size: 16px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
    }

    .desc {
      font-size: 12px;
      margin-top: 20px;
      line-height: 20px;
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
    }
  }
}

@keyframes film {
  0% {
    transform: translateY(-36%);
    opacity: 0;
  }
  66.66% {
    transform: translateY(-12%);
    opacity: 0.4;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

</style>
